<template>
  <sf-calculator-stats class="calculator__stats">
    <template slot-scope="{ data }">
      <template v-if="infoVisible">
        <div>
          <div>{{ $t('calculator.principal') }}</div>
          <div v-qa="'calculator-amount'">{{ data.principal | money }}</div>
        </div>

        <div>
          <div>{{ $t('calculator.repay-date') }}</div>
          <div v-qa="'calculator-endDate'">{{ data.endDate | date }}</div>
        </div>

        <div>
          <div>{{ $t('calculator.interest') }}</div>
          <div v-qa="'calculator-interest'" :class="{ discount: discountInterest }">
            <span
              v-if="discountInterest"
              v-qa="'calculator-interest-without-discount'"
              class="discount-without">
              {{ data.interestWithoutDiscount | moneyWithDecimal }}
            </span>
            {{ data.interest | moneyWithDecimal }}
          </div>
        </div>

        <div>
          <div>{{ $t('calculator.service-fee') }}</div>
          <div v-qa="'calculator-serviceFee'">{{ data.serviceFee | moneyWithDecimal }}</div>
        </div>

        <div>
          <div>{{ $t('calculator.total') }}</div>
          <div v-qa="'calculator-total'" :class="{ discount: discountTotal }">
            <span
              v-if="discountTotal"
              v-qa="'calculator-total-without-discount'"
              class="discount-without">
              {{ data.totalWithoutDiscount | moneyWithDecimal }}
            </span>
            {{ data.total | moneyWithDecimal }}
          </div>
        </div>
      </template>
    </template>
  </sf-calculator-stats>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CalculatorStats',
  props: {
    infoVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('arithmetic', ['displayed']),
    discountInterest() {
      return Number(this.displayed.interest) < Number(this.displayed.interestWithoutDiscount);
    },
    discountTotal() {
      return Number(this.displayed.total) < Number(this.displayed.totalWithoutDiscount);
    },
  },
};
</script>

<style scoped lang='scss'>
.discount {
  &-without {
    position: relative;
    font-size: 12px;
    font-weight: normal;
    margin-right: map_get($margins, xsmall);
    color: map-get($colors, error);

    &:before {
      content: '';
      position: absolute;
      top: 6px;
      width: 100%;
      height: 1px;
      background-color: map-get($colors, error);
      transform: rotate(-10deg);
    }
  }
}
</style>
